export const basePath = "/store/app";
export const parentBaseUrl = "/store/";
